function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { su, theme, typography } from '@arc/frontend/ui-theme';
import { inputStyles } from '../Inputs';
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "s5zram",
  styles: "outline:2px solid transparent;outline-offset:2px"
} : {
  name: "ex37xg---focus",
  styles: "outline:2px solid transparent;outline-offset:2px;label:--focus;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const baseContainer = ({
  error,
  disabled,
  archived,
  readOnly
}) => /*#__PURE__*/css(inputStyles.inputContainer, error && inputStyles.inputContainerError, disabled && inputStyles.inputContainerDisabled, archived && inputStyles.inputContainerArchived, readOnly && inputStyles.inputContainerReadOnly,
// Remove reach's :focus styles
{
  '&:focus': _ref2
}, process.env.NODE_ENV === "production" ? "" : ";label:baseContainer;");
const baseInput = ({
  disabled,
  archived,
  readOnly
}) => /*#__PURE__*/css(inputStyles.input, disabled && inputStyles.inputContainerDisabled, archived && inputStyles.inputArchived, readOnly && inputStyles.inputReadOnly, process.env.NODE_ENV === "production" ? "" : ";label:baseInput;");
var _ref = process.env.NODE_ENV === "production" ? {
  name: "s5zram",
  styles: "outline:2px solid transparent;outline-offset:2px"
} : {
  name: "1u0lkdf---focus-within",
  styles: "outline:2px solid transparent;outline-offset:2px;label:--focus-within;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const selectorStyles = {
  container: status => baseContainer(status),
  multiselectContainer: status => /*#__PURE__*/css(baseContainer(status),
  /**
   * Because multiselect layout accommodates in-container item display,
   * container has different styles
   */
  su.roundedSm, "flex-wrap:wrap;align-items:center;justify-content:flex-start;gap:0.25rem;padding-left:0.25rem;padding-right:0.25rem;padding-top:0.125rem;padding-bottom:0.125rem;min-height:42px;", status.disabled || status.readOnly ? {
    cursor: 'default'
  } : null, process.env.NODE_ENV === "production" ? "" : ";label:multiselectContainer;"),
  input: status => baseInput(status),
  multiselectInput: status => /*#__PURE__*/css(baseInput(status),
  /**
   * Because multiselect layout accommodates in-container item display,
   * input has different styles
   */
  "display:flex;flex:1 1 0%;padding-left:0.5rem;padding-top:0px;padding-bottom:0px;margin:0px;min-width:4rem;",
  // Because you don't copy from input, change cursor
  status.readOnly && {
    cursor: 'default'
  }, process.env.NODE_ENV === "production" ? "" : ";label:multiselectInput;"),
  comboboxButton: process.env.NODE_ENV === "production" ? {
    name: "x678vi",
    styles: "min-width:40px;height:38px;display:flex;align-items:center;justify-content:space-around"
  } : {
    name: "ufatmt-comboboxButton",
    styles: "min-width:40px;height:38px;display:flex;align-items:center;justify-content:space-around;label:comboboxButton;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  adornmentIcon: /*#__PURE__*/css({
    color: theme.colors.input.adornment,
    width: '1.25rem',
    height: '1.25rem',
    cursor: 'pointer'
  }, process.env.NODE_ENV === "production" ? "" : ";label:adornmentIcon;"),
  popover: (maxHeight, maxWidth) => /*#__PURE__*/css({
    backgroundColor: theme.colors.white
  }, su.roundedSm, su.shadowMd, {
    borderColor: theme.colors.input.focusedBorder,
    paddingTop: '0px',
    paddingBottom: '0px',
    overflow: 'auto',
    borderWidth: '1px',
    borderStyle: 'solid',
    outline: '2px solid transparent',
    outlineOffset: '2px',
    maxHeight,
    maxWidth,
    // Remove reach's :focus styles
    '&:focus-within': _ref
  }, process.env.NODE_ENV === "production" ? "" : ";label:popover;"),
  list: /*#__PURE__*/css({
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',
    // Put space between children.
    '& > * + *': process.env.NODE_ENV === "production" ? {
      name: "1a7e1yb",
      styles: "margin-top:0.25rem"
    } : {
      name: "fwm0q1----------",
      styles: "margin-top:0.25rem;label:---------;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    },
    // Remove reach's :focus styles
    '&:focus': process.env.NODE_ENV === "production" ? {
      name: "s5zram",
      styles: "outline:2px solid transparent;outline-offset:2px"
    } : {
      name: "ex37xg---focus",
      styles: "outline:2px solid transparent;outline-offset:2px;label:--focus;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:list;"),
  listItem: /*#__PURE__*/css(typography.regular, {
    display: 'flex',
    justifyContent: 'left',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.colors.background.dropdown.hoverItemBackground
    },
    '&[data-highlighted], &.Mui-focusVisible': {
      backgroundColor: theme.colors.background.dropdown.selectItemBackground
    },
    '&[aria-selected="true"]': /*#__PURE__*/css({
      color: theme.colors.palettes.primary.main
    }, process.env.NODE_ENV === "production" ? "" : ";label:--aria-selected--true--;"),
    '&[aria-disabled="true"]': {
      opacity: 0.5,
      cursor: 'default',
      // disable hover styles
      '&:hover': {
        backgroundColor: 'inherit'
      }
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:listItem;"),
  // Centers the text in each selection button (ComboboxOption) so
  // that text is directly in the middle of the button.
  // Apply text-align to parent to align the text left or right.
  // Stops longer text from clipping into the selection button below
  text: process.env.NODE_ENV === "production" ? {
    name: "4vkv4w",
    styles: "transform:translateY(-50%);position:relative;top:50%"
  } : {
    name: "1n2m41n-text",
    styles: "transform:translateY(-50%);position:relative;top:50%;label:text;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  highlightMatch: {
    '& [data-user-value]': {
      backgroundColor: 'yellow'
    }
  },
  listTitle: /*#__PURE__*/css(typography.regular, {
    color: theme.colors.text.faint,
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem'
  }, process.env.NODE_ENV === "production" ? "" : ";label:listTitle;"),
  emptyListItem: /*#__PURE__*/css("padding-left:0.5rem;padding-right:0.5rem;padding-bottom:0.5rem;", typography.emptySmall, process.env.NODE_ENV === "production" ? "" : ";label:emptyListItem;"),
  tagValueContainer: process.env.NODE_ENV === "production" ? {
    name: "b8h8ft",
    styles: "display:flex;align-items:center;justify-content:space-between;width:100%;padding-right:0.5rem"
  } : {
    name: "136kye7-tagValueContainer",
    styles: "display:flex;align-items:center;justify-content:space-between;width:100%;padding-right:0.5rem;label:tagValueContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  tagEditWrapper: process.env.NODE_ENV === "production" ? {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
  } : {
    name: "13imavx-tagEditWrapper",
    styles: "display:flex;align-items:center;label:tagEditWrapper;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  label: /*#__PURE__*/css(typography.label, "padding-left:0.75rem;margin-bottom:0.25rem;min-height:0.9rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:label;"))
};